import type { SelectChangeEvent } from "@mui/material";
import { type ChangeEvent } from "react";
import type { Dimensions, EmbeddingsInputs, Model } from "../../../services/api/instances/embeddingsApi/types";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { getEmbeddingsVectorsAction } from "../redux/actions";
import { selectInputValues, selectModels, selectSelectedModel } from "../redux/selectors";
import { setInputValues, setSelectedModelAction, updateInputValues } from "../redux/slice";

export const useEmbeddingsSettings = () => {
  const dispatch = useAppDispatch();
  const models = useAppSelector(selectModels);
  const selectedModel = useAppSelector(selectSelectedModel);
  const inputValues = useAppSelector(selectInputValues);

  const addInputValue = () => {
    const newInputValue = {
      id: String(inputValues.length + 1),
      value: "",
    };
    dispatch(setInputValues([...inputValues, newInputValue]));
  };

  const deleteInputValue = (id: string) => {
    const newInputValues = inputValues.filter((input) => input.id !== id);
    dispatch(setInputValues(newInputValues));
  };

  const handleInputChange = (id: string, event: ChangeEvent<HTMLInputElement>) => {
    const activeInput = inputValues.find((input) => input.id === id);
    dispatch(updateInputValues({ ...activeInput, value: event.target.value } as EmbeddingsInputs));
  };

  const handleSelectModel = (event: SelectChangeEvent<Model>) => {
    const model = models.find((item) => item.name === event.target.value);
    dispatch(setSelectedModelAction(model as Model));
  };

  const handleModeling = () => {
    const postObj = {
      sentences: inputValues.map((item) => item.value),
      embedding_method: selectedModel?.name as string,
      dimensions: 2 as Dimensions,
    };

    dispatch(getEmbeddingsVectorsAction(postObj));
  };

  return {
    addInputValue,
    deleteInputValue,
    handleInputChange,
    handleSelectModel,
    handleModeling
  };
};